module.exports = __webpack_public_path__ + "static/media/translate.ac617c6e.svg";